<template>
  <div class="panel">
    <div class="panel-heading" @click="$emit('click')" @keyup.enter="$emit('click')">
      <slot name="header" :title="title">
        <h3 class="panel-title">
          {{ title }}
        </h3>
      </slot>
      <b
        v-if="showCaret"
        :style="isTitleClicked ? 'transform: rotate(180deg)' : ''"
        class="caret"
      />
    </div>
    <div v-if="$slots.default" v-tooltip="tooltip" class="panel-body">
      <slot />
    </div>
    <div v-if="$slots.footer" class="panel-footer hidden-xs">
      <slot name="footer" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'PanelComponent',
  props: {
    tooltip: {
      type: String,
      required: false,
      default: '',
    },
    title: {
      type: String,
      required: false,
      default: '',
    },
    showCaret: {
      type: Boolean,
      default: false,
    },
    isTitleClicked: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
};
</script>

<style scoped>
.caret {
  display: inline-block;
  float: right;
  position: relative;
  bottom: 12px;
  border-right: 6px solid transparent;
  border-left: 6px solid transparent;
  border-top: 6px dashed;
}
</style>
